module.exports = __webpack_public_path__ + "static/img/P8.278b73d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mszj/P8.png
// module id = Tv/Z
// module chunks = 0